import { render } from "./ItemDeliveries.vue?vue&type=template&id=c64fb64c&scoped=true"
import script from "./ItemDeliveries.vue?vue&type=script&lang=js"
export * from "./ItemDeliveries.vue?vue&type=script&lang=js"

import "./ItemDeliveries.vue?vue&type=style&index=0&id=c64fb64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64fb64c"]])

export default __exports__